'use strict';

(function (angular) {

    angular.module('zp').factory('ResultModel', resultModelFactory);

    /**ngInject */
    function resultModelFactory() {

        function ResultModel(data) {
            this.id = data && data.id ? data.id : null;
            this.name = data && data.name ? data.name : '';
            this.address = data && data.location ? data.location.address : '';
            this.city = data && data.city ? data.city : '';
            this.image = data && data.image ? data.image : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSenMve532bF8SrIt0779nbGpSk7fLAAmB062QRzEITw2rd5ofH';
            this.stickers = data && data.stickers ? data.stickers : [];
            this.images = data && data.images ? data.images : 0;
            this.location = data && data.location ? data.location : {};

            // Venue specific properties used for filtering
            this.type = data && data.type ? data.type : null;
            this.discount = data ? data.discount : false;
            this.maxCapacity = data && data.maxCapacity ? data.maxCapacity : 0;
            this.description = data && data.description ? data.description : null;
            this.category = data && data.category ? data.category : null;
            this.favsCount = data && data.favsCount ? data.favsCount : 0;
            this.likeCount = data && data.likeCount ? data.likeCount : 0;
        }

        ResultModel.prototype.match = function (filters) {
            var match = true;
            for (var i = 0; i < filters.length; i++) {
                if (filters[i].selectedValue || filters[i].selectedValue === 0 || filters[i].selectedValue === false) {
                    if (this['_' + filters[i].match + 'Match']) {
                        match = this['_' + filters[i].match + 'Match'](filters[i]);
                    }
                }
                if (!match) {
                    break;
                }
            }
            return match;
        };

        ResultModel.prototype._containsMatch = function (filter) {
            if (filter.selectedValue === '*') {
                return true;
            }
            return this[filter.property] && this[filter.property].toLowerCase().indexOf(filter.selectedValue.toLowerCase()) !== -1;
        };

        ResultModel.prototype._exactMatch = function (filter) {
            if (filter.selectedValue === '*') {
                return true;
            }
            return this[filter.property] === filter.selectedValue;
        };

        ResultModel.prototype._rangeMatch = function (filter) {
            if (!this[filter.property]) {
                return false;
            }
            var min = parseInt(filter.selectedValue.min, 10);
            var max = parseInt(filter.selectedValue.max, 10);
            var val = parseInt(this[filter.property], 10);
            return min < val && val < max;
        };

        return ResultModel;
    }
})(window.angular);